document.addEventListener('DOMContentLoaded', async () => {

    function updatePriceSavingForContainers(rrp, price) {
        const priceSelectors = [
            ".summary-side-panel .price .price__container",
            ".price-display .price .price__container",
            ".price-mob-container .price .price__container"
        ];
        for (const selector of priceSelectors) {
            const priceContainer = document.querySelector(selector);
            if (!priceContainer) {
                continue;
            }

            // Get DOM elements and price values
            const priceSaving = priceContainer.querySelector('span.price-saving');
            const rrpPrice = priceContainer.querySelector('span.rrp');
            const rrpPriceLabel = priceContainer.querySelector('span.rrp-label');

            // Update RRP display if available
            if (rrp && rrp > 0 && rrpPrice) {
                rrpPrice.innerHTML = `&pound; ${(rrp / 100).toFixed(2)}`;
                if (rrpPriceLabel) rrpPriceLabel.innerText = 'New RRP';

                // Show or hide savings based on price comparison
                if (priceSaving) {
                    if (rrp > price) {
                        const savingsPercentage = Math.round((rrp - price) / rrp * 100);
                        if (savingsPercentage > 0) {
                            priceSaving.innerText = `-${savingsPercentage}%`;
                            priceSaving.classList.remove('hidden');
                            rrpPrice.classList.add('rrp-price-line-through');
                        }
                    } else {
                        priceSaving.classList.add('hidden');
                        rrpPrice.classList.remove('rrp-price-line-through');
                    }
                }
            }
        }
    }

    document.addEventListener("variant:updated", (event) => {
        if (!event.detail || !event.detail.variantId || !window.originalVariantsData) {
            return;
        }
        const variant = getVariantById(window.originalVariantsData, event.detail.variantId);
        if (!variant) {
            return;
        }
        updatePriceSavingForContainers(variant.rrpPrice, variant.price);
    });

    document.addEventListener("update-saving", (event) => {
        if (!event.detail) {
            return;
        }
        const price = Number.parseInt(event.detail.price, 10);
        const rrp = Number.parseInt(event.detail.rrpPrice, 10);
        updatePriceSavingForContainers(rrp, price);
    });
});
